<template>
  <div v-loading="tableLoading" class="dataTableRefames">
    <el-table
      ref="dataTableRefames"
      :data="tableData"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      stripe
      sortable="custom"
    >
      <el-table-column
        v-if="selection"
        type="selection"
        width="55"
      />
      <el-table-column
        v-for="(item,index) in columns"
        :key="index"
        :prop="item.prop"
        :width="item.width"
        :align="item.align"
        :fixed="item.fixed?item.fixed:false"
        :label="item.label"
        :sortable="item.label=='交易时间'"
      >
        <template slot-scope="scope">
          <span v-if="item.label=='描述'">
            <p> {{ scope.row['TRADE_DESC_TITLE'] }}</p>
            <p style="color:#999999;font-size: 12px">
              {{ scope.row['TRADE_DESC_CONTENT'] }}
            </p>
          </span>
          <div v-if="item.label=='收支'">
            <p :class="scope.row['WALLET_AMOUNT']>0?'jia':'jian'">
              <span v-if="scope.row['WALLET_AMOUNT']>0">+</span>
              <span>{{ scope.row['WALLET_AMOUNT'] }}</span>
            </p>
          </div>
          <span v-if="item.label!='收支'&&item.label!='描述'">{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageNation">
      <el-pagination
        :current-page="option.param.index"
        :page-size="option.pageSize"
        :total="total"
        :layout="option.pagination.layout"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { loadWallet, loadIndex, loadIntegral, loadPublicity } from '@/api/api.js'
export default {
  filters: {
    // changeCity: res => {
    //   if (res) {
    //     return res + '-'
    //   }
    // }
  },
  props: {
    dataType: {
      type: String
    },
    up: {
      type: Boolean,
      default() {
        return false
      }
    },
    option: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    selection: {
      type: Boolean,
      default() {
        return false
      }
    },
    hander: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data: function() {
    return {
      isfirst: true,
      total: 0,
      tableLoading: true,
      tableData: [],
      defaultOption: {
        ajax: {},
        pagination: {
          layout: 'total, sizes, prev, pager, next, jumper',
          pageSizes: [5, 10, 20, 50]
        },
        param: {
          index: 1
        },
        pageSize: 10,
        dataDirUrl: {
          total: ['data', 'count'],
          tableData: ['data', 'listMapData']
        }
      }
    }
  },
  watch: {
    option: {
      handler(newName, oldName) {
        if (newName.param.passportid) {
          this.fetchData(newName.param)
        }
      },
      deep: true
    },
    up: {
      handler(newName, oldName) {
        this.fetchData(this.option.param)
      },
      deep: true
    }
  },
  created() {
    this.fixParam()
    this.fetchData(this.option.param)
  },
  updated() {
    // this.fetchData(this.option.param)
  },
  mounted() {

  },
  methods: {
    /* 组件内调用方法*/
    fixParam() {
      for (var obj in this.option) {
        this.defaultOption[obj] = this.option[obj]
      }
      for (var obsj in this.defaultOption) {
        this.option[obsj] = this.defaultOption[obsj]
      }
    },
    formUrlToData(data, array) {
      var reData = JSON.parse(JSON.stringify(data))
      for (var i in array) {
        reData = reData[array[i]]
      }
      return reData
    },
    handleSizeChange(sizes) {
      this.option.param.index = 1
      this.option.param.size = sizes
      // this.fetchData(this.option.param)
    },
    handleCurrentChange(page) {
      this.option.param.index = page
      // this.fetchData(this.option.param)
    },
    showExpands(row, bol) {
      if (bol) {
        row.expoLLSs = !row.expoLLSs
        this.$refs.dataTableRefames.toggleRowExpansion(row)
      }
    },
    /* 数据操作*/
    fetchData(params) {
      if (this.isfirst) {
        this.isfirst = false
        if (this.dataType == 'wallerDetails') {
          loadWallet({ passportid: this.option.param.passportid }).then(res => {
            this.total = res.data[this.dataType].count
            this.listData = res.data[this.dataType].listMapData
            this.tableLoading = false
          })
        }
        if (this.dataType == 'integralsDetails') {
          loadIntegral({ passportid: this.option.param.passportid }).then(res => {
            this.total = res.data[this.dataType].count
            this.listData = res.data[this.dataType].listMapData
            this.tableLoading = false
          })
        }
        if (this.dataType == 'publicityDetails') {
          loadPublicity({ passportid: this.option.param.passportid, index: 1, size: 5 }).then(res => {
            this.total = res.data[this.dataType].count
            this.listData = res.data[this.dataType].listMapData
            this.tableLoading = false
          })
        }
      } else {
        params = this.option.param
        this.tableLoading = true
        request({
          url: this.option.ajax.url,
          method: this.option.ajax.type ? this.option.ajax.type : 'get',
          params: params
        }).then(res => {
          this.total = this.formUrlToData(res, this.option.dataDirUrl.total)
          this.tableData = this.formUrlToData(res, this.option.dataDirUrl.tableData)
          this.tableLoading = false
        }).catch(() => {})
      }
    }
    // handleSelectionChange(val) {
    //   this.$emit('handelSelect', val)
    // }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .pageNation{
        padding-top: 40px;
        text-align: center;
    }
    .showExpands{
        display: inline-block;
        float: right;
        svg{
            color: #b3b3b3;
        }
    }
    .dataTableRefames{
        margin-bottom: 20px;
    }
    /* 数据表格样式
    *  初始定义
    *     每个不同可单独定义
    *     一般每个项目建议表格的样式一致
    */
    .dataTableRefames .el-icon{
        display: none;
    }
    .jia{
        color: #20A634;
    }
    .jian{
        color: #EDA33B;
    }
</style>
